import React from "react";
import defaultAvatar from "../../images/avatar.png";
import { editIcon, eyeIcon } from "utils/constant";

interface UserCardProps {
  avatarUrl: string;
  name: string;
  role: string;
  time: string;
  date: string;
  onDelete?: () => void;
  user?: any;
  title?: string;
  description?: string;
  openEditPopup?: React.SetStateAction<React.Dispatch<boolean>>;
  children?: React.ReactNode;
  onEdit?: () => void;
  disabled?: boolean;
  onView?: () => void; // Add this prop
}

export const UserCard: React.FC<UserCardProps> = ({
  avatarUrl,
  name,
  role,
  time,
  date,
  user,
  onDelete,
  title,
  description,
  children,
  onEdit,
  disabled,
  onView // Add this prop
}) => {
  return (
    <div className="flex items-center justify-between p-2 border-b">
      {/* Left side: Avatar + Name + Role */}
      <div className="flex items-center space-x-3">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={name}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <img
            src={defaultAvatar}
            alt="avatar"
            className="w-10 h-10 rounded-full"
          />
        )}
        <div>
          <p className="font-medium text-sm text-gray-900">{name}</p>
          <p className="text-[12px] text-gray-500">{role}</p>
        </div>
      </div>

      {/* Right side: Time + Delete */}
      <div className="flex items-center space-x-3 text-sm text-gray-500">
        <button 
          onClick={onView} // Use the onView prop
          className="ml-4"
        >
          <span className="sr-only">View</span>
          {eyeIcon}
        </button>
        <button 
          onClick={onEdit} 
          className="ml-4" 
          disabled={disabled} 
          style={disabled?{cursor:"not-allowed"}:{cursor:"pointer"}}
        >
          <span className="sr-only">Edit</span>
          {editIcon}
        </button>
      </div>
    </div>
  );
};